import Controller from 'controllers/controller';
import Elements from 'tools/elements';
import Binder from 'tools/binder';
import EventManager from 'tools/event-manager';
import Animator from 'tools/animator';

class ModalController extends Controller {
    constructor(app, modal) {
        super(app);
        
        this.modal = modal;
        this.id = this.modal.getAttribute('id');
        this.binder = new Binder(this);
        this.elements = new Elements(this.modal);
        this.animator = new Animator({
            elements: this.elements.all()
        });
        this.events = new EventManager({
            bind: this
        });
        
        this.cacheElements();
        this.attachEvents();
    }
    
    cacheElements() {
        this.elements.save('modal', this.modal);
        this.elements.queryOne('close', '.close-modal');
    }
    
    attachEvents() {
        this.events.on(this.elements.get('close'), 'click', this.onCloseModalClick);
        this.app.modalsController.on('backdrop-clicked', this.binder.bind('onBackdropClick'));
    }

    removeEvents() {
        this.events.off();
        this.app.modalsController.off('backdrop-clicked', this.binder.bind('onBackdropClick'));
    }

    onBackdropClick() {
        this.close();
    }

    onCloseModalClick() {
        this.close();
    }
    
    close() {
        this.app.modalsController.hideBackdrop();
        
        this.animator.to('modal', {
            y: -30,
            opacity: 0,
            onComplete: () => {
                this.animator.set('modal', {
                    display: 'none'
                });

                this.app.modalsController.emit(this.id + '-modal-closed');
            }
        })
    }
    
    open() {
        this.app.modalsController.showBackdrop();
        
        this.animator.fromTo('modal', {
            display: 'block',
            y: -30,
            opacity: 0
        }, {
            y: 0,
            opacity: 1,
            onComplete: () => {
                this.app.modalsController.emit(this.id + '-modal-opened');
            }
        });
    }
    
    destroy() {
        this.removeEvents();
    }
}

export default ModalController;